import DSInput from "@/componentsDS/Input";
import { getEnvAndDex } from "@/utils/get-env-and-dex";
import {
	validateDomain,
	validateEmail,
} from "@/utils/validate-email";
import PropTypes from "prop-types";


const PersonalInfo = ({
	errors,
	register,
	setValue,
}) => {
	const { dex } = getEnvAndDex();
	return (
		<>
			<div className="login-box__section-title-buildex">
				Personal Information
			</div>
			<div className="login-box__form__cols--buildex">
				<div className="login-box__form__col login-box__form__col">
					<DSInput
						name="firstName"
						label="First Name"
						placeholder="Enter name"
						errorMessage={errors.firstName?.message}
						required={true}
						id="first-name-input"
						fullWidth={true}
						register={register({
							required: "This field is mandatory",
						})}
						setValue={setValue}
					/>
				</div>
				<div className="login-box__form__col login-box__form__col">
					<DSInput
						name="lastName"
						label="Last Name"
						placeholder="Enter name"
						errorMessage={errors.lastName?.message}
						required={true}
						id="last-name-input"
						fullWidth={true}
						register={register({
							required: "This field is mandatory",
						})}
						setValue={setValue}
					/>
				</div>
				<div className="login-box__form__col login-box__form__col--half">
					<DSInput
						name="email"
						label="Company Email Address"
						placeholder="Enter company email"
						errorMessage={errors.email?.message}
						required={true}
						id="email-input"
						fullWidth={true}
						setValue={setValue}
						register={register({
							required: "This field is mandatory",
							validate: {
								checkEmail: (v) =>
									!v || validateEmail(v) ||
									"Please enter a valid company email address",
								checkDomain: (v) =>
									!v || validateDomain(v, dex) ||
									"The following domain are not allowed to be registered",
							},
						})}
					/>
				</div>
			</div>
		</>
	);
};

export default PersonalInfo

PersonalInfo.propTypes = {
	errors: PropTypes.objectOf(
		PropTypes.shape({
			message: PropTypes.string,
		})
	).isRequired,
	register: PropTypes.func.isRequired,
	setValue: PropTypes.func.isRequired,
}